import {ChangeDetectorRef, Component, HostListener, ViewEncapsulation} from '@angular/core';
import {CcBaseComponent} from '../../crystal-elements/cc-base.component';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from '../../services/app-config.service';
import {ConfigServiceProvider} from "../../services/config/config.service.provider";
import {ThemeService} from "../../services/tools/theme.service";
import {CcStorageService} from "../../services/common/cc-storage.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ConfigServiceProvider
  ]
})
export class LoginComponent extends CcBaseComponent {

  dialogHelpVisible: boolean = false;

  constructor(
    private themeService: ThemeService,
    cdref: ChangeDetectorRef,
    messageService: MessageService,
    translateService: TranslateService,
    private storageService: CcStorageService,
    public appConfigService: AppConfigService
  ) {
    super(cdref, messageService, translateService);
    this.themeService.initDefaultTheme();
  }

  // ngAfterViewInit() {
  //   const shell = document.querySelector('.login-shell');
  //   if (!shell) return;
  //
  //   const trySrcs = [
  //     '/assets/backgrounds/abstract-city-16x9@2x.avif',
  //     // '/assets/backgrounds/abstract-city-16x9@2x.webp',
  //     // '/assets/backgrounds/abstract-city-16x9@2x.png'
  //   ];
  //
  //   const img = new Image();
  //   let i = 0;
  //
  //   const loadNext = () => {
  //     if (i >= trySrcs.length) return; // give up silently
  //     img.src = trySrcs[i++];
  //   };
  //
  //   img.onload = () => shell.classList.add('is-ready');
  //   img.onerror = loadNext;
  //
  //   loadNext(); // kick off preload
  // }

  @HostListener('document:keydown.control.alt.shift.x', ['$event'])
  shiftRepeatX(e: KeyboardEvent) {
    this.storageService.deleteAll();
    this.infoMessage("All cookies have been digested");
  }

}
